module.exports = __webpack_public_path__ + "img/android.0345bf52.jpg";